import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
// import { composeWithDevTools } from "redux-devtools-extension";
import reducers from "./state/reducers";
import sagas from "./state/sagas";

// TODO: This project was originally created in 2019 and does not need Redux
// It can be refactored to avoid Redux

export const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

let store = createStore(reducers, middleware);

if (sagas) {
	sagaMiddleware.run(sagas);
}

export default store;
